module.exports = __webpack_public_path__ + "img/exchange.a0160edb.svg";